/**
 * API client for Centre Operations -> Annual Calendar (read for everyone,
 * edited from HQ -> Centre Operations -> Annual Calendar).
 *
 * Backend: oh_operations Django app, alfred-suffixed endpoints under
 * /api/v1/oh_operations/annual_calendar/. Every `apiEndpoints.X` reference
 * lives INSIDE a function body (TDZ-safety — mirrors newJoiners.js).
 */
import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get, patch, post, remove } from '../request'

// {year, years, calendar, calendars, kinds, audiences, can_edit, days};
// year = the June it starts in, calendar = bangalore | corp | kolkata
const fetchAnnualCalendar = async (year, calendar) => {
  try {
    const response = await get(
      makeRequestUrl(`${apiEndpoints.annualCalendar}/alfred`, {
        ...(year ? { year } : {}),
        ...(calendar ? { calendar } : {})
      })
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching annual calendar')
    throw error
  }
}

// {calendar, start_date, end_date?, label, kind, audiences, notes?} -> the new entry
const createCalendarDay = async (body) => {
  try {
    const response = await post(`${apiEndpoints.annualCalendar}/alfred`, body)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in creating calendar day')
    throw error
  }
}

const updateCalendarDay = async (uuid, body) => {
  try {
    const response = await patch(
      `${apiEndpoints.annualCalendar}/${uuid}/alfred`,
      body
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in updating calendar day')
    throw error
  }
}

const deleteCalendarDay = async (uuid) => {
  try {
    await remove(`${apiEndpoints.annualCalendar}/${uuid}/alfred`)
  } catch (error) {
    sentryLogger(error, 'error in deleting calendar day')
    throw error
  }
}

// {days_off: {calendar: {date: [group]}}, centre_calendars: {centre: calendar}}
const fetchCalendarDaysOff = async ({ from, to }) => {
  try {
    const response = await get(
      makeRequestUrl(`${apiEndpoints.annualCalendar}/days_off/alfred`, {
        from,
        to
      })
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching calendar days off')
    throw error
  }
}

export {
  fetchCalendarDaysOff,
  fetchAnnualCalendar,
  createCalendarDay,
  updateCalendarDay,
  deleteCalendarDay
}
